<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="adminId" :confirm="true"
                    :title="$t('Modify') + ' ' + $t('a') + ' ' + $t('admin')" route-back="AdminIndex"/>
        <back-arrow v-else :confirm="askConfirm" :title="$t('Add') + ' ' + $t('a')  + ' ' +  $t('admin')"
                    route-back="AdminIndex"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm card-scrollable">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.lastName.invalidFeedback"
                    :label="$t('admin.lastName')"
                    :state="form.lastName.state"
                    class="medium-label mb-4 required-input"
                    label-for="lastName-input">
                    <b-form-input
                      id="lastName-input"
                      v-model="form.lastName.value"
                      :state="form.lastName.state"
                      maxlength="250"
                      required
                      tabindex="1"
                      type="text"
                      v-on:change="removeInvalidFeedback('lastName');askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.firstName.invalidFeedback"
                    :label="$t('admin.firstName')"
                    :state="form.firstName.state"
                    class="medium-label mb-4 required-input"
                    label-for="firstName-input">
                    <b-form-input
                      id="firstName-input"
                      v-model="form.firstName.value"
                      :state="form.firstName.state"
                      maxlength="250"
                      required
                      tabindex="2"
                      type="text"
                      v-on:change="removeInvalidFeedback('firstName'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.phoneNumber.invalidFeedback"
                    :label="$t('admin.phoneNumber')"
                    :state="form.phoneNumber.state"
                    class="medium-label mb-4 required-input"
                    label-for="phoneNumber-input">
                    <vue-phone-number-input
                      id="phone-input"
                      v-model="form.phoneNumber.inputValue"
                      :error="form.phoneNumber.error"
                      :placeholder="$t('admin.phoneNumber')"
                      tabindex="3"
                      required
                      @update="checkPhone"/>
                  </b-form-group>
                </div>

                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.username.invalidFeedback"
                    :label="$t('admin.username')"
                    :state="form.username.state"
                    class="medium-label mb-4 required-input"
                    label-for="username-input">
                    <b-form-input
                      id="username-input"
                      v-model="form.username.value"
                      :state="form.username.state"
                      required
                      tabindex="4"
                      type="email"
                      v-on:change="removeInvalidFeedback('username'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <b-button tabindex="13" type="submit" variant="primary">
                  {{ adminId ? $t('Modify') : $t('Add') + ' ' + $t('l.i') + $t('admin') }}
                </b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

    <user-already-exist></user-already-exist>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import PasswordCreationField from '../../components/b122/editFields/PasswordCreationField'
import UserAlreadyExist from '../user/UserAlreadyExist'
import {bus} from '../../main'

export default {

  name: 'AdminCreateEdit',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField,
    UserAlreadyExist
  },

  data () {
    return {
      adminId: this.$route.params.adminId,
      askConfirm: false,
      form: {
        firstName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            error: null,
            value: null,
            inputValue: null
          }
      },
      admin: {}
    }
  },

  mounted () {
    this.fetchData()
  },

  created () {
    bus.$on('handleSubmit', this.submitCreateEdit)
  },
  beforeDestroy () {
    bus.$off('handleSubmit', this.submitCreateEdit)
  },
  methods: {
    handlePasswordInfos (state, invalidFeedback, value) {
      this.form.password.state = state
      this.form.password.invalidFeedback = invalidFeedback
      this.form.password.value = value
    },

    async fetchData () {
      if (this.adminId) {
        await this.fetchAdmin()
      }
    },

    async fetchAdmin () {
      api
        .get('/admin/' + this.adminId)
        .then(response => {
          this.admin = response.data
          this.setInitialValues()
        })
    },

    setInitialValues () {
      if (this.admin != null) {
        this.form.firstName.value = this.admin.firstName
        this.form.lastName.value = this.admin.lastName
        this.form.username.value = this.admin.username
        this.form.phoneNumber.value = this.admin.phoneNumber
        this.form.phoneNumber.inputValue = this.admin.phoneNumber
      }
    },

    async onSubmit () {
      await this.fetchUserAlreadyExist()
    },

    async fetchUserAlreadyExist () {
      let data = new FormData()
      data.append('username', this.form.username.value)
      if (this.admin.id) {
        data.append('adminId', this.admin.id)
      }
      await api({
        method: 'post',
        url: '/admin/isUserAlreadyExist',
        data: data
      })
        .then(async (response) => {
          if (response.status === 200) {
            await this.submitCreateEdit()
          } else if (response.status === 202) {
            if (response.data.user) {
              bus.$emit('toggleModal', response.data.user)
            }
          }
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'AdminIndex'
            })
          } else {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    async submitCreateEdit () {
      let data = new FormData()
      data.append('firstName', this.form.firstName.value)
      data.append('lastName', this.form.lastName.value)
      data.append('username', this.form.username.value)
      data.append('phoneNumber', this.form.phoneNumber.value.e164)

      let url = 'admin'
      if (this.adminId) {
        url = '/admin/' + this.adminId
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then((response) => {
          this.structure = response.data
          this.$router.push({
            name: 'AdminIndex'
          },
          () => {
            this.$nextTick(() => {
              this.successToast(this.form.firstName.value + ' ' + this.form.lastName.value)
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'AdminIndex'
            })
          } else {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    removeInvalidFeedback (field) {
      this.form[field]['state'] = null
    },
    checkPhone (value) {
      this.form.phoneNumber.error = false
      this.form.phoneNumber.value = value
      this.removeInvalidFeedback('phoneNumber')
      this.askConfirm = true
    },

    successToast (taskName) {
      this.$bvToast.toast(this.$i18n.t('Admin') + ' "' + taskName + '" ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/admin/AdminCreateEdit.vue